import React from 'react';
import { Link } from 'react-router-dom';

export default function SiteHeader() {
  return (
    <header className="site-header">
      <Link to="/" className="site-header-brand">
        <img src="/logo192.png" alt="Chill Ras" className="site-header-logo" />
        <span className="site-header-name">
          <span className="site-header-name-dark">Chill</span>{' '}
          <span className="site-header-name-light">Ras</span>
        </span>
      </Link>
      <nav className="site-header-nav">
        <Link to="/">Home</Link>
        <Link to="/partner-program">Partner Program</Link>
        <a href="/#locations">Locations</a>
        <a href="/#contact">Contact</a>
      </nav>
    </header>
  );
}
